module.exports = __webpack_public_path__ + "static/media/red-trash-icon.97c60424.svg";